import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLoadWithErrorCatcher } from '../../components/AppPreloading/hooks/useLoadWithErrorCatcher';
import { useSetupLoadEnd } from '../../components/AppPreloading/hooks/useSendLoadStartEventToPlatform';
import AppSkeleton from '../../components/AppSkeleton/AppSkeleton';
import * as commonActions from '../../state/actions/common';
import useSelector from '../useSelector';
import { useWalkmeSdkService } from '../WalkmeSdkProvider/useWalkmeSdkService';

const AuthorizationGate = ({ children }: { children: JSX.Element | JSX.Element[] }) => {
  const dispatch = useDispatch();
  const setupLoadEndEvent = useSetupLoadEnd();
  const loadWithErrorCatcher = useLoadWithErrorCatcher();
  const { walkmeSdkService } = useWalkmeSdkService();
  const authorized = useSelector(state => state.common.authorized);
  useEffect(() => {
    if (!authorized) {
      setupLoadEndEvent();
      loadWithErrorCatcher(() => dispatch(commonActions.authorize(walkmeSdkService)));
    }
  }, [authorized, dispatch, loadWithErrorCatcher, setupLoadEndEvent, walkmeSdkService]);
  return (authorized  ? children : <AppSkeleton />) as JSX.Element;
};

export default AuthorizationGate
